import React from 'react';
import { motion } from 'framer-motion';

interface AnimatedImageProps {
  src: string;
  alt: string;
  className?: string;
}

const AnimatedImage: React.FC<AnimatedImageProps> = ({ src, alt, className = '' }) => {
  return (
    <motion.div>
      <img
        src={src}
        alt={alt}
        className={`${className}`}
      />
    </motion.div>
  );
}

export default AnimatedImage;